import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => setMenuOpen(false), [location]);

  const links = [
    { label: 'Home',    to: '/' },
    { label: 'About',   to: '/about' },
    { label: 'Privacy', to: '/privacy' },
    { label: 'Support', to: '/support' },
    { label: 'Contact Us', to: '/contact' },
  ];

  const isActive = (to) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      height: 68,
      padding: '0 clamp(1rem, 4vw, 3rem)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      background: scrolled ? 'rgba(8,15,24,0.95)' : 'transparent',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(232,96,74,0.12)' : 'none',
      transition: 'background 0.4s, backdrop-filter 0.4s, border-color 0.4s',
    }}>
      {/* Logo */}
      <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
        <img
          src="/imags/hadafi_white_logo.png"
          alt="Hadafi"
          style={{ height: 42, width: 'auto', display: 'block' }}
        />
      </Link>

      {/* Desktop links */}
      <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
        {links.map(({ label, to }) => (
          <Link key={to} to={to} style={{
            textDecoration: 'none',
            fontFamily: 'var(--font-d)', fontSize: 14, fontWeight: 700,
            letterSpacing: 2, textTransform: 'uppercase',
            color: isActive(to) ? 'var(--coral)' : 'var(--muted)',
            borderBottom: isActive(to) ? '2px solid var(--coral)' : '2px solid transparent',
            paddingBottom: 2,
            transition: 'color 0.2s, border-color 0.2s',
          }}>{label}</Link>
        ))}
        <a href="#download" className="shimmer-btn" style={{
          background: 'var(--coral)', border: 'none',
          fontFamily: 'var(--font-d)', fontSize: 14, fontWeight: 700,
          letterSpacing: 2, textTransform: 'uppercase',
          color: '#fff', padding: '10px 24px', borderRadius: 4,
          textDecoration: 'none', display: 'inline-block',
        }}>Download Free</a>
      </div>
    </nav>
  );
}
